import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Stack,
  Chip,
  Button,
} from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

const GiftCards = () => {
  return (
    <>
    <Helmet>
      <title>Gift Cards | Den Den Claw Ottawa</title>
      <meta
        name="description"
        content="Give the gift of claw machines! Den Den Claw gift cards are perfect for birthdays and special occasions — redeemable at our Ottawa arcade."
      />
      <link rel="canonical" href="https://www.dendenclaw.com/explore/gift-cards" />
    </Helmet>
    <Box sx={{ py: 6 }}>
      <Container maxWidth="sm">
        {/* ---------- HEADER ---------- */}
        <Typography
          variant="h4"
          sx={{ fontWeight: 700, textAlign: "center", mb: 2 }}
        >
          Gift Cards 🎁
        </Typography>

        <Typography
          variant="subtitle1"
          sx={{
            textAlign: "center",
            mb: 6,
            color: "text.secondary",
          }}
        >
          We’re working on gift cards so you can share the Den Den Claw experience
          with friends and family!
        </Typography>

        {/* ---------- PLACEHOLDER IMAGE ---------- */}
        <Box
          component="img"
          src="/giftcards/placeholder.jpg" // TODO: add gift card image
          alt="Den Den Claw gift cards"
          sx={{
            width: "100%",
            maxHeight: 300,
            objectFit: "cover",
            borderRadius: 3,
            mb: 6,
          }}
        />

        {/* ---------- WIP CARD ---------- */}
        <Card
          sx={{
            borderRadius: 3,
            boxShadow: 6,
            p: 4,
            textAlign: "center",
            background: "linear-gradient(180deg, #e8f2ff 0%, #f5faff 100%)",
          }}
        >
          <CardContent>
            <Chip
              label="Coming Soon ✨"
              color="primary"
              sx={{ mb: 3, fontWeight: 600 }}
            />

            <Typography sx={{ mb: 3 }}>
              Gift cards will be available for purchase in-store and will be
              redeemable for tokens to play our claw machines and photo booth.
            </Typography>

            <Typography sx={{ fontWeight: 600, mb: 2 }}>
              Planned Gift Card Options:
            </Typography>

            <Stack spacing={1} alignItems="center" sx={{ mb: 4 }}>
              <Typography>🎮 $15 for 25 Tokens</Typography>
              <Typography>🎮 $30 for 50 Tokens</Typography>
            </Stack>

            <Typography
              variant="body2"
              sx={{ mb: 4, color: "text.secondary" }}
            >
              Pricing and availability subject to change.
              Check back soon or ask staff in-store for updates!
            </Typography>

            {/* ---------- VISIT US CTA ---------- */}
            <Button
              variant="contained"
              size="large"
              component={Link}
              to="/contact"
              sx={{
                borderRadius: 999,
                px: 4,
                textTransform: "none",
                fontWeight: 600,
              }}
            >
              Visit Us
            </Button>
          </CardContent>
        </Card>
      </Container>
    </Box>
    </>
  );
};

export default GiftCards;
